(function () {
  'use strict';

  function hasCarouselContent(root) {
    return !!root.querySelector('.l-related-products__carousel, .l-product-card');
  }

  function loadRecommendations(root) {
    if (!root || root.dataset.lRelatedLoaded === '1' || root.dataset.lRelatedLoaded === 'loading') return;
    const url = root.dataset.url;
    if (!url) return;

    root.dataset.lRelatedLoaded = 'loading';

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const sectionId = root.dataset.sectionId;
        const fresh =
          (sectionId && doc.getElementById('shopify-section-' + sectionId)) ||
          doc.querySelector('.product-recommendations');

        if (!fresh) {
          root.dataset.lRelatedLoaded = 'error';
          return;
        }

        const content = fresh.classList && fresh.classList.contains('product-recommendations')
          ? fresh.innerHTML
          : (fresh.querySelector('.product-recommendations') || fresh).innerHTML;

        if (!content || !content.trim()) {
          root.dataset.lRelatedLoaded = 'empty';
          const skeleton = root.querySelector('.l-related-products__skeleton');
          if (skeleton) skeleton.remove();
          return;
        }

        root.innerHTML = content;
        root.dataset.lRelatedLoaded = '1';
        delete root.dataset.url;

        if (window.LimendaTutus && typeof window.LimendaTutus.initScope === 'function') {
          window.LimendaTutus.initScope(root);
        }
      })
      .catch(function () {
        root.dataset.lRelatedLoaded = 'error';
      });
  }

  function initRecommendations(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-l-related-products][data-url]').forEach(function (el) {
      if (el.dataset.lRelatedObserved) return;
      el.dataset.lRelatedObserved = '1';

      if (hasCarouselContent(el)) {
        if (window.LimendaTutus && typeof window.LimendaTutus.initScope === 'function') {
          window.LimendaTutus.initScope(el);
        }
        return;
      }

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              observer.unobserve(entry.target);
              loadRecommendations(entry.target);
            });
          },
          { rootMargin: '300px' }
        );
        observer.observe(el);
        loadRecommendations(el);
      } else {
        loadRecommendations(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initRecommendations();
    });
  } else {
    initRecommendations();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initRecommendations(e.target);
  });
})();
